// extracted by mini-css-extract-plugin
module.exports = {"leftSider":"siderMenu_leftSider__3cm8s","asideWrap":"siderMenu_asideWrap__1ABZb","asideContent":"siderMenu_asideContent__3KCI2"};